import React, { useState } from "react"
import {
  addressItemAddress,
  addressItemCompAddress,
  addressItemVoie,
  addressItemName,
  addressItemTitle,
  addressItemContacts,
  addressItemTel,
  addressItemMail,
  addressItemMailMobile,
  addressItemTooltip,
  addressItemTooltipMobile,
  addressMore,
  pasteButton,
  pasteButtonImg,
} from "../carnet-adresse.module.scss"
import { AddressTitle, StyledLink, MailButton } from "./address-content-styled"
import PropTypes from "prop-types"
import TransitionFade from "gatsby-theme-blank/src/components/transition-fade"
import Obfuscate from "react-obfuscate"
import paste from "gatsby-theme-blank/src/images/paste.png"
import Icon from "gatsby-theme-blank/src/components/Icon/icon"

const AddressContent = ({ address }) => {
  const [emailVisible, setEmailVisible] = useState(false)
  return (
    <>
      <TransitionFade className={addressItemName} link={address.path.alias}>
        <AddressTitle className={addressItemTitle}>
          {address.title}
        </AddressTitle>
        <div className={addressItemAddress}>
          <div className={addressItemVoie}>
            {address.field_adresse?.address_line1}
          </div>
          <div className={addressItemCompAddress}>
            {address.field_adresse?.address_line2}
          </div>
          <div>
            {address.field_adresse?.postal_code}{" "}
            {address.field_adresse?.locality}
          </div>
        </div>
        {address.field_telephone && (
          <Obfuscate tel={address.field_telephone} className={addressItemTel} />
        )}
      </TransitionFade>
      <div className={addressItemContacts}>
        {!address.field_mail ? null : (
          <>
            <StyledLink
              className={addressItemMail}
              href={`mailto:${address.field_mail}`}
            >
              <Icon size={28} icon="mail"></Icon>
            </StyledLink>
            <div className={addressItemTooltip}>
              <Obfuscate element="span">{address.field_mail}</Obfuscate>
              <button
                className={pasteButton}
                onClick={(event) => {
                  event.preventDefault()
                  navigator.clipboard.writeText(address.field_mail)
                  alert("Email copié avec succès")
                }}
              >
                <img
                  alt="copiercoller"
                  className={pasteButtonImg}
                  src={paste}
                />
              </button>
            </div>
            <p
              role="presentation"
              onClick={() => setEmailVisible(true)}
              onKeyDown={() => setEmailVisible(true)}
              className={addressItemMailMobile}
            >
              {emailVisible === true && (
                <MailButton
                  href={`mailto:${address.field_mail}`}
                  style={{ textAlign: "left" }}
                  className={addressItemTooltipMobile}
                >
                  {address.field_mail}
                </MailButton>
              )}
            </p>
          </>
        )}
        <StyledLink className={addressMore} href={address.path.alias}>
          <Icon size={24} icon="info"></Icon>
        </StyledLink>
      </div>
    </>
  )
}

AddressContent.propTypes = {
  address: PropTypes.object.isRequired,
}

export default AddressContent
